const scenario_anke = [
  {//0
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"afb442e7-8330-4fad-9cc0-cfc673020e99",
    "beforenodeX":73,
    "beforenodeY":59,
    "start_flg":true,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":2
    },
    "parameter":[],
    "mainmessage":"\u30a2\u30f3\u30b1\u30fc\u30c8\u306b\u3054\u5354\u529b\u3044\u305f\u3060\u304d\u307e\u3057\u3066\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3059\u3002\n\u6b21\u306e\u8cea\u554f\u306b\u304a\u7b54\u3048\u3044\u305f\u3060\u3051\u307e\u3059\u3088\u3046\u304a\u9858\u3044\u3044\u305f\u3057\u307e\u3059\u3002",
    "status":2,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"cc0a1422-cce2-4826-ade3-a5c4dec0c0f4",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30169
  },
  {//1
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"cc0a1422-cce2-4826-ade3-a5c4dec0c0f4",
    "beforenodeX":72,
    "beforenodeY":186,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u540d\u524d",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u304a\u540d\u524d\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"3f0cbada-544a-412d-96aa-ce9e4e9e74d8",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30172
  },
  {//2
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"3f0cbada-544a-412d-96aa-ce9e4e9e74d8",
    "beforenodeX":445,
    "beforenodeY":192,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"Email",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"Email\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"8973d5ca-e739-434f-8ace-d3556675e715",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30173
  },
  {//3
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"8973d5ca-e739-434f-8ace-d3556675e715",
    "beforenodeX":804,
    "beforenodeY":190,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"TEL",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u96fb\u8a71\u756a\u53f7\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"900605e5-6b45-44dd-b15b-3314462f7760",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30174
  },
  {//4 address
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"900605e5-6b45-44dd-b15b-3314462f7760",
    "beforenodeX":1152,
    "beforenodeY":190,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u4f4f\u6240",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"\u4f4f\u6240\u3092\u5165\u529b\u3057\u3066\u304f\u3060\u3055\u3044[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"7a41dab7-92e5-46bb-b324-6340b17be86a",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30175
  },
  {//5
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"7a41dab7-92e5-46bb-b324-6340b17be86a",
    "beforenodeX":71,
    "beforenodeY":374,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$1[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"d48af4db-6765-44d4-99a1-bd9673088451",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30184
  },
  {//6
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"d48af4db-6765-44d4-99a1-bd9673088451",
    "beforenodeX":440,
    "beforenodeY":378,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$2[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"c3544470-2a57-4514-97d0-c2af11fea304",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30177
  },
  {//7
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"c3544470-2a57-4514-97d0-c2af11fea304",
    "beforenodeX":800,
    "beforenodeY":384,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$3[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"867a3c24-9ad7-477b-aae3-2c8e34a98bb1",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30178
  },
  {//8
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"867a3c24-9ad7-477b-aae3-2c8e34a98bb1",
    "beforenodeX":1145,
    "beforenodeY":391,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"",
      "custom_tag":"",
      "apply_flg":false,
      "any_flg":false
    },
    "mainmessage":"$4[input][/input]",
    "status":6,
    "select":[
      {
        "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
        "input_type":"free",
        "custom_tag":"",
        "custom":"",
        "default_birth":"",
        "date_type":"",
        "apply_flg":false,
        "any_flg":false,
        "default_flg":false,
        "keep_time_hour":0,
        "keep_time_minute":0
        }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30179
  },
  {//9
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"ee44125b-c79e-4f2d-8750-4dbece69127e",
    "beforenodeX":1494,
    "beforenodeY":394,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":6
    },
    "parameter":{
      "colomn_name":"\u8a2d\u5b9a\u306a\u3057",
      "input_type":"free",
      "custom_tag":"",
      "custom":"",
      "default_birth":"",
      "date_type":"",
      "apply_flg":false,
      "any_flg":false,
      "default_flg":false,
      "keep_time_hour":0,
      "keep_time_minute":0
    },
    "mainmessage":"$5[input][/input]",
    "status":6,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"667dca68-627c-4ee5-a60c-ba8e80ecf916",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":true,
    "is_confirm":false,
    "pk":30180
  },
  {//10
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"667dca68-627c-4ee5-a60c-ba8e80ecf916",
    "beforenodeX":67,
    "beforenodeY":504,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":10
    },
    "parameter":{
      "title":"\u30a2\u30f3\u30b1\u30fc\u30c8\u306e\u56de\u7b54\u304c\u3054\u3056\u3044\u307e\u3057\u305f\u3002",
      "to":"",
      "cc":"",
      "after":0
    },
    "mainmessage":"<p>\u3054\u62c5\u5f53\u8005\u69d8</p><p><br></p><p>\u304a\u4e16\u8a71\u306b\u306a\u3063\u3066\u304a\u308a\u307e\u3059\u3002</p><p>\u30a2\u30f3\u30b1\u30fc\u30c8\u306e\u56de\u7b54\u304c\u3054\u3056\u3044\u307e\u3057\u305f\u306e\u3067</p><p>\u3054\u78ba\u8a8d\u306e\u307b\u3069\u3088\u308d\u3057\u304f\u304a\u9858\u3044\u3044\u305f\u3057\u307e\u3059\u3002</p><p><br></p><p>---</p><p><br></p><p>\u304a\u540d\u524d\uff1a__applicant__</p><p>Email\uff1a__email__</p><p>TEL\uff1a__tel__</p>",
    "status":10,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"c11929c5-a3b7-4070-8687-3a2d79e87485",
        "point":""
      }
    ],
    "template":"",
    "is_cv":true,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30187
  },
  {//11
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"c11929c5-a3b7-4070-8687-3a2d79e87485",
    "beforenodeX":71,
    "beforenodeY":617,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":0
    },
    "parameter":[],
    "mainmessage":"\u3054\u8a18\u5165\u9802\u304d\u3042\u308a\u304c\u3068\u3046\u3054\u3056\u3044\u307e\u3057\u305f\u3002\n\u62c5\u5f53\u304b\u3089\u3054\u9023\u7d61\u3044\u305f\u3057\u307e\u3059\u306e\u3067\u4eca\u3057\u3070\u3089\u304f\u304a\u5f85\u3061\u304f\u3060\u3055\u3044\u3002",
    "status":0,
    "select":[
      {
        "msg_type":"button",
        "message":"\u6700\u521d\u3078\u623b\u308b",
        "text_option":"white",
        "next_node":"1d16fcb1-dc78-485b-8098-b40a56d381bf",
        "point":"0"
      }
    ],
    "template":"[button]\u6700\u521d\u3078\u623b\u308b,white[/button]",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30185
  },
  {//12
    "name":"template",
    "robo_parts_set": '',
    "beforenode":"1d16fcb1-dc78-485b-8098-b40a56d381bf",
    "beforenodeX":443,
    "beforenodeY":677,
    "start_flg":false,
    "is_edit":true,
    "start":{
      "pvcount":"",
      "focuscount":"",
      "clickcount":"",
      "condition":9
    },
    "parameter":[],
    "mainmessage":"[restart][/restart]",
    "status":9,
    "select":[
      {
        "msg_type":"",
        "message":"",
        "text_option":"",
        "next_node":"",
        "point":""
      }
    ],
    "template":"",
    "is_cv":false,
    "image":"",
    "image_ref":"",
    "movie":"",
    "movie_ref":"",
    "quote_flg":false,
    "is_confirm":false,
    "pk":30186
  },
]

export {
  scenario_anke
}


// WEBPACK FOOTER //
// ./src/assets/data/tutorial_scenario_anke.js